import axios from "axios";
import { PushNotification } from "../Models/PushNotification";

const client = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});

export const SendNotification = (notification: PushNotification, token: string) => {
    return client.post('notifications', notification, { headers: {"Authorization" : `Bearer ${token}`}});
}